const isDesktop = () =>
  typeof window !== "undefined" && Boolean(window.desktopProducts);

// Web continues to use the API. Electron reads SQLite first, then refreshes it.
export const getCachedProducts = async (restaurantId, source = "default") => {
  if (!restaurantId || !isDesktop()) return null;
  try {
    const products = await window.desktopProducts.get({ restaurantId, source });
    return Array.isArray(products) ? products : null;
  } catch (error) {
    console.warn("Unable to read the local product cache", error);
    return null;
  }
};

export const cacheProducts = async (restaurantId, products, source = "default") => {
  if (!restaurantId || !Array.isArray(products) || !isDesktop()) return;
  try {
    await window.desktopProducts.set({ restaurantId, source, products });
  } catch (error) {
    console.warn("Unable to update the local product cache", error);
  }
};
